import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status !== 401 || cfg._retry || url.startsWith("/auth/")) throw error;
    cfg._retry = true;
    refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
    await refreshing;
    return api(cfg);
  },
);

export const errText = (e, fallback = "Qualcosa è andato storto. Riprova.") => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return typeof d?.msg === "string" ? d.msg : String(d);
};

const Ctx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/auth/me")
      .catch(() => api.post("/auth/refresh"))
      .then((r) => { if (alive) setUser(r.data); })
      .catch(() => { if (alive) setUser(false); });
    return () => { alive = false; };
  }, []);
  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  }, []);
  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);
  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
};

export const useAdminAuth = () => useContext(Ctx);
